// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './utils/perf'; // Initialize performance tracking

// Debug environment variables (development only)
if (import.meta.env.DEV) {
  console.log('Starting Stock Vision App');
  console.log('VITE_POLYGON_API_KEY exists:', !!import.meta.env.VITE_POLYGON_API_KEY);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  // <StrictMode>
  <App />
  // </StrictMode>
);
